exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3xbS8M97OSf4SOeO37hcit{padding:40px 60px}._182kyereRb-To05980vkFD{color:#757575;height:80px;width:80px;border:2px solid #c8e6dc;border-radius:100%;display:flex;align-items:center;justify-content:center;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"FourOhFour": "_3xbS8M97OSf4SOeO37hcit",
	"icon": "_182kyereRb-To05980vkFD"
};